import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as e } from "react";
import { I as l } from "../../../../IconBase-CxZyIWw2.js";
const s = e((r, i) => /* @__PURE__ */ o.jsx(
  l,
  {
    ref: i,
    ...r,
    image: (t) => /* @__PURE__ */ o.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 9,
        height: 4,
        fill: "none",
        viewBox: "0 0 9 4",
        ...t,
        children: /* @__PURE__ */ o.jsx(
          "path",
          {
            fill: "currentColor",
            d: "M5.207 3.536 8.743 0H.257l3.536 3.536a1 1 0 0 0 1.414 0"
          }
        )
      }
    )
  }
));
s.displayName = "TooltipTriangleIcon";
export {
  s as TooltipTriangleIcon,
  s as default
};
//# sourceMappingURL=index.js.map
